export const getEmailHref = (email) => {
  return "mailto:" + email;
};
